import styled from "styled-components";
import InputMask from "react-input-mask";
import { Input } from "@rocketseat/unform";
import { darken } from "polished";
import "../../../index.scss";
import "../../../styles/sass/Pages/_newDesign.scss";

export const Container = styled.div`
	height: 100%;
	background: #23242f;

	@media only screen and (max-device-width: 900px) {
		width: 100%;
		background: #13141b;
	}

	&.recover-pincode-container {
		width: 50%;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	align-content: center;
	height: 100%;
	justify-content: flex-end;

	@media only screen and (max-device-width: 900px) {
		flex-direction: column;
	}
`;

export const Box = styled.div`
	width: 50%;
	display: flex;
	justify-content: center;

	@media only screen and (max-width: 800px) {
		width: 100%;
	}

	@media only screen and (max-device-width: 380px) {
		width: 85%;
	}
`;

export const Content = styled.section`
	max-width: 27rem;
	height: 100%;
	background: #23242f;
	z-index: 1000;

	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	font-family: "MetropolisRegular";

	@media only screen and (max-device-width: 900px) {
		background: #13141b;
		position: relative;
		max-width: 23rem;
		height: 90%;
		justify-content: flex-start;
	}

	form {
		opacity: 1;
		width: 100%;
		max-width: 27rem;
		padding: 30px 0;
	}
`;

export const Title = styled.div`
	color: #ffffff;
	font-size: 24px;
	font-family: var(--font-family-metropolis-semi-bold);
	width: 100%;
	padding-bottom: 0.5rem;
`;

export const Subtitle = styled.span`
	font-size: 16px;
	color: #ffffff;
	font-family: "MetropolisRegular";
	padding-bottom: 1.5rem;

	button {
		color: #01e59b;
		font-family: var(--font-family-metropolis-semi-bold);
		outline: none !important;
		background: none;
		border: none;

		&:hover {
			text-decoration: underline;
		}
	}

	b {
		font-family: var(--font-family-metropolis-semi-bold);
	}
`;

export const Label = styled.label`
	font-size: 12px;
	font-family: "MetropolisRegular";
	color: #ffffff;
`;

export const InputCpf = styled(InputMask).withConfig({
	shouldForwardProp: (props) => props !== "error",
})`
	font-family: "MetropolisRegular";
	font-size: 16px;

	border: solid 2px ${(props) => (!props.error.value ? "#353546" : "#D30D48")} !important;

	&:focus {
		border: solid 2px ${(props) => (!props.error.value ? "#01E59B" : "#D30D48")} !important;
	}

	&:focus {
		border: solid 2px #01e59b;
	}
`;

export const ContainerPinCode = styled.div`
	padding-top: 13px;
	width: 100%;

	@media only screen and (max-device-width: 900px) {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		flex-direction: column;
	}
`;

export const FormGroupInput = styled.div`
	position: relative;
	padding-top: 13px;
	width: 100%;

	input {
		font-size: 16px;
		color: #ffffff;
		padding: 16px;
		border: solid 2px #353546;
		height: 56px;
		width: 100%;
		outline: none;
		z-index: 1;
		background-color: transparent;
		border-radius: 8px;
	}

	label {
		font-family: var(--font-family-metropolis-semi-bold);
		margin-bottom: 4px;
	}
`;

export const InputText = styled(Input)`
	background: #00000000;
	font-family: "MetropolisRegular";
	color: #ffffff;
	border-radius: 8px;
	font-size: 16px;
	padding: 16px;
	width: 27rem;
	height: 56px;

	border: solid 2px ${(props) => (!props.error.value ? "#353546" : "#D30D48")} !important;

	&:focus {
		border: solid 2px ${(props) => (!props.error.value ? "#01E59B" : "#D30D48")} !important;
	}
`;

export const DivButton = styled.div`
	display: flex;
	width: 100%;
	height: 40px;
	margin: 24px 0 8px;
	justify-content: space-between;
	align-items: center;
	background: #353546;
	border-radius: 10px;
	padding: 5px;
`;

export const ButtonActive = styled.button`
	width: 50%;
	background-color: #01e59b;
	color: #13141b;
	border: none;
	padding: 10px;
	border-radius: 8px;
	font-family: var(--font-family-metropolis-semi-bold);
	height: 32px;
	outline: none !important;
`;

export const ButtonInactive = styled.button`
	width: 50%;
	background-color: transparent;
	border: none;
	padding: 10px;
	border-radius: 8px;
	color: #ffffff;
	font-family: var(--font-family-metropolis-semi-bold);
	height: 32px;
	outline: none !important;
`;

export const SubmitButtom = styled.button`
	width: 100%;
	margin-top: 40px;
	background-color: #01e59b;
	border-radius: 8px;
	align-self: center;
	color: #13141b;
	padding: 5px;
	border: 0px;
	font-size: 16px;
	height: 40px;
	font-family: var(--font-family-metropolis-semi-bold);
	outline: none !important;

	&:hover {
		background: ${darken(0.03, "#01E59B")};
	}

	&:disabled {
		opacity: 0.24;
	}
`;

export const MessageError = styled.span`
	color: #d30d48;
	font-family: var(--font-family-metropolis-semi-bold);
	font-size: 12px;
`;

// ________________________________________ CONFIRM_PINCODE ________________________________________

export const ButtonContainer = styled.div`
	margin-top: 40px;
	width: 100%;
`;

export const ButtonRecover = styled.button`
	display: flex;
	justify-content: center;
	background: transparent;
	color: #01e59b;
	text-decoration: none;
	font-size: 16px;
	width: 13rem;
	height: 40px;
	border: 2px solid #01e59b;
	border-radius: 8px;
	align-items: center;
	font-family: var(--font-family-metropolis-semi-bold);
	outline: none !important;

	&:hover {
		color: #01e59b;
		text-decoration: underline;
	}

	img {
		margin-right: 4px;
	}

	@media only screen and (max-device-width: 900px) {
		width: 11.2rem;
	}

	@media only screen and (max-device-width: 380px) {
		width: 9.75rem;
	}
`;

export const TextResend = styled.label`
	font-size: 16px;
	font-family: "MetropolisRegular";
	color: #ffffff;
`;

export const ButtonRecoverEmail = styled.button`
	background: transparent;
	border: 0;
	color: #01e59b;
	text-decoration: none;
	font-size: 16px;
	font-family: var(--font-family-metropolis-semi-bold);
	outline: none !important;

	&.centered {
		display: flex;
		justify-content: center;
	}

	&:hover {
		color: #01e59b;
		text-decoration: underline;
	}
`;

export const FormGroupLine = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	color: #ffffff;
	margin-bottom: 2%;

	button {
		border: none;
		outline: none;
	}

	@media only screen and (max-device-width: 768px) {
		margin-top: 0px;
		width: 100%;
	}
`;

export const DivButtonConfirm = styled.div`
	display: flex;
	justify-content: ${(props) => (props.type ? "center" : "space-between")};
	font-family: var(--font-family-metropolis-semi-bold);
`;

export const DivTimer = styled.div`
	display: flex;
	justify-content: center;
	font-family: "MetropolisRegular";
	margin-top: 48px;
	width: 100%;

	span {
		color: #01e59b;
		font-size: 16px;
	}
`;

export const HelpContainer = styled.div`
	margin-top: 2.5rem;
`;

export const TitleHelp = styled.div`
	color: #ffffff;
	font-size: 20px;
	font-family: var(--font-family-metropolis-semi-bold);
	width: 100%;
	padding-bottom: 0.5rem;
`;

export const FormSupport = styled.form`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	overflow-x: auto;
`;

export const FormSubmit = styled.div`
	margin-top: 2.5rem;
	width: 100%;
`;
